package ru.villawonka.app.presentation.screens.searchFilter.compose.layout

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Scaffold
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.platform.platform.model.PlatformType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.ApplyButtonBlockView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.CityCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.CostRangeCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.DistrictsCardView
import ru.villawonka.app.presentation.screens.searchFilter.compose.view.SearchFilterTopBar
import ru.villawonka.app.presentation.screens.searchFilter.viewmodel.SearchFilterUIState

@Composable
fun SearchFilterTransportStateLayout(
    platformType: PlatformType,
    state: SearchFilterUIState.Data.Transport,
    callbacks: SearchFilterCallbacks,
) {
    Scaffold(
        topBar = {
            if (platformType != PlatformType.TELEGRAM) SearchFilterTopBar(callbacks)
        }
    ) {
        val betweenCardSpacing = 8.dp
        val bottomSpacing = 88.dp

        Box (modifier = Modifier.fillMaxSize()) {
            Column(modifier = Modifier.verticalScroll(rememberScrollState())) {
                CityCardView(
                    selectedCity = state.selectedCity,
                    cities = state.cities,
                    callbacks = callbacks,
                )
                AppSpacer(betweenCardSpacing)
                if (state.districts.isNotEmpty()) {
                    DistrictsCardView(
                        chips = state.districts,
                        callbacks = callbacks
                    )
                    AppSpacer(betweenCardSpacing)
                }
                CostRangeCardView(
                    costMin = state.minCost,
                    costMax = state.maxCost,
                    currency = state.currency,
                    callbacks = callbacks
                )
                AppSpacer(bottomSpacing)
            }
            ApplyButtonBlockView(platformType, callbacks)
        }
    }
}